// extracted by mini-css-extract-plugin
export default {"fs":"bb0f8f9660 _8a4bcbf075"};